import DatePickr from 'components/Common/DatePickr'
import Modal from 'components/Common/Modal/Modal'
import { OptionsInput } from 'components/Common/OptionsInput'
import SearchInput from 'components/Common/SearchInput'
import { NOTIFICATION_TYPE, NOTIFICATIONTYPE_COLOR } from 'constants/notificationType'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { getManagerList } from 'store/actions'


export const NotificationsFilterModal = ({ handleOnChange,
	handleOnChangeDateRange,
	objectData,
	resetState,
	setObjectData,
	handleApiCall,
	handleInitialApiCall,
	cancelApiCall,
	setKeyword,
	keyword,
	resetDateRange, t, selectedManagersIds, notificationsUpdated, notificationCreated, managerList, getManagerList }) => {

	const [isModalOpen, setIsModalOpen] = useState(false)

	const notificationTypeOptions = [
		{ value: NOTIFICATION_TYPE.OfferPublished, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[1]}`}>{t('OfferPublished', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.OrderDelayed, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[2]}`}>{t('OrderDelayed', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.OrderSent, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[3]}`}>{t('OrderSent', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.OrderPublished, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[4]}`}>{t('OrderPublished', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.ErrorPayment, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[5]}`}>{t('ErrorPayment', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.QuotePublished, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[6]}`}>{t('QuotePublished', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.ProdRejected, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[7]}`}>{t('ProdRejected', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.QualityIncidence, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[8]}`}>{t('QualityIncidence', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.ProdDelayedNotified, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[9]}`}>{t('ProdDelayedNotified', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.ProdDelayed, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[10]}`}>{t('ProdDelayed', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.ProdRetention, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[11]}`}>{t('ProdRetention', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.OfferNoOpened, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[12]}`}>{t('OfferNoOpened', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.CrmNotification, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[13]}`}>{t('CrmNotification', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.NewOffer, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[14]}`}>{t('NewOffer', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.ProdNotAccepted, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[15]}`}>{t('ProdNotAccepted', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.GenericTask, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[16]}`}>{t('GenericTask', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.OrderTask, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[17]}`}>{t('OrderTask', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.OfferTask, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[18]}`}>{t('OfferTask', { ns: 'naming' })}</span> },
		{ value: NOTIFICATION_TYPE.CustomerTask, label: <span className={`rounded-pill end-ellipsis text-white bg-${NOTIFICATIONTYPE_COLOR[19]}`}>{t('CustomerTask', { ns: 'naming' })}</span> },
	]

	useEffect(() => {
		setObjectData((prevData) => ({
			...prevData,
			managers: selectedManagersIds || [],
		}))
	}, [selectedManagersIds])

	useEffect(() => {
		if (isModalOpen) {
			return
		}
		handleApiCall()
	}, [objectData, keyword, notificationCreated])



	const handleApplyFilters = () => {
		handleApiCall()
		setIsModalOpen(false)
	}

	const handleOnCleanFilters = () => {
		handleInitialApiCall()
		setIsModalOpen(false)
	}




	return (
		<div className='mx-2 d-flex flex-row bg-white ps-2'>
			<SearchInput onChange={(e) => setKeyword(e)} />
			<button className='btn btn-secondary' onClick={() => setIsModalOpen(true)}>{t('filter', { ns: 'naming' })}</button>
			<Modal
				title={t('filter', { ns: 'naming' })}
				isOpen={isModalOpen}
				closeModal={() => setIsModalOpen(false)}
				buttons={[
					<button id="resetFilterButton" key="resetFilter" className='btn btn-primary' onClick={() => { handleOnCleanFilters() }}>{t('clean', { ns: 'naming' })}</button>,
					<button className='btn btn-primary' key="apply-filters-button" onClick={() => { handleApplyFilters() }}>{t('apply', { ns: 'naming' })}</button>,
				]}
				body={
					<div className='p-4'>
						<OptionsInput
							isMulti
							setValue={handleOnChange}
							objectElement='notificationTypeId'
							value={objectData.notificationTypeId}
							options={notificationTypeOptions}
							title={t('notification_type', { ns: 'naming' })}
							automaticMappedValue
						/>

						<DatePickr
							mode={'range'}
							format={'Y-m-d'}
							value={[objectData.dateRange?.startDate, objectData.dateRange?.endDate]}
							setValue={handleOnChangeDateRange}
							title={t('date_range_notification', { ns: 'naming' })}
							objectElement={'dateRange'}
							placeholder={t('start_end_date', { ns: 'naming' })}
							cleanData={() => setObjectData({ ...objectData, dateRange: { startDate: null, endDate: null } })}
						/>
					</div>
				}
			/>
		</div>
	)
}

NotificationsFilterModal.propTypes = {
	selectedManagersIds: PropTypes.array,
	handleOnChange: PropTypes.func,
	handleOnChangeDateRange: PropTypes.func,
	objectData: PropTypes.object,
	resetState: PropTypes.func,
	setObjectData: PropTypes.func,
	handleApiCall: PropTypes.func,
	handleInitialApiCall: PropTypes.func,
	cancelApiCall: PropTypes.func,
	setKeyword: PropTypes.func,
	keyword: PropTypes.string,
	resetDateRange: PropTypes.func,
	notificationsUpdated: PropTypes.bool,
	managerList: PropTypes.array,
	getManagerList: PropTypes.func,
}

const mapStateToProps = (state) => ({
	notificationsUpdated: state.Users.notificationsUpdated,
	notificationCreated: state.Users.notificationCreated,
	managerList: state.Users.managerList,
})

const mapDispatchToProps = {
	getManagerList
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NotificationsFilterModal))

